import { useContext, useState } from "react";
import "./DropdownMenu.scss"; // Make sure to import the SCSS file
import { MainContext } from "../../MainContext";
import MenuIcon from "@mui/icons-material/Menu";

const DropdownMenu = () => {
	const {
		texts: { navbar: texts },
		setLang,
		updateAll,
		aboutUsRef,
		handleScroll,
		headingRef,
		wrapperRef,
		cardRefs,
		translationRef,
		polygraphTypesRef,
		analysisServicesRef,
    languageCoursesRef,
    staticTexts: { menuEducationalCourses: menuEducationalCourses },
    staticTexts: { menuPhonoscopy: menuPhonoscopy },
    staticTexts: { menuOurService: menuOurService },
    staticTexts: { menuTranslationService: menuTranslationService },
    staticTexts: { menuLinguisticExpertise: menuLinguisticExpertise },
    staticTexts: { menuLatestPost: menuLatestPost },
    staticTexts: { menuOurTeam: menuOurTeam },
    staticTexts: { menuAboutUs: menuAboutUs },

	} = useContext(MainContext);
	const [open, setOpen] = useState(false);

	const handleClick = (ref: React.RefObject<HTMLElement>) => {
		handleScroll(ref);
		setOpen(false);
	};

	return (
		<div className="menu_dropdown">
			<button className="dropdown__toggle" onClick={() => setOpen(!open)}>
				<MenuIcon />
			</button>
			{open && (
				<div className="dropdown__menu">
					<ul>
						<li onClick={() => handleClick(aboutUsRef)}>{menuAboutUs.text}</li>
						<li onClick={() => handleClick(headingRef)}>{menuOurTeam.text}</li>
						<li onClick={() => handleClick(wrapperRef)}>{menuLatestPost.text}</li>
						<li onClick={() => handleClick(cardRefs)}>{menuLinguisticExpertise.text}</li>
						<li onClick={() => handleClick(translationRef)}>{menuTranslationService.text}</li>
						<li onClick={() => handleClick(polygraphTypesRef)}>{menuOurService.text}</li>
						<li onClick={() => handleClick(analysisServicesRef)}>{menuPhonoscopy.text}</li>
						<li onClick={() => handleClick(languageCoursesRef)}>{menuEducationalCourses.text}</li>
					</ul>
				</div>
			)}
		</div>
	);
};

export default DropdownMenu;
